import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=17e3b2fa&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e3b2fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17e3b2fa')) {
      api.createRecord('17e3b2fa', component.options)
    } else {
      api.reload('17e3b2fa', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=17e3b2fa&scoped=true&", function () {
      api.rerender('17e3b2fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QDeX9E4o6ykp/JS/comp/Accordion.vue"
export default component.exports